import React, { useContext, useEffect } from "react";
import textile from "textile-js";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import { baseStyle } from "../assets/theme/default";
import TextileView from "./atoms/textile_view";
import CustomAvatar from "./atoms/custom_avatar";
import AppContext from "../contexts/AppContext";
import { useUsers } from "../hooks/useUsers";

const useStyles = makeStyles((theme) => baseStyle);

const NoteList = (props) => {
  const { state } = useContext(AppContext);
  const { getUser } = useUsers();
  const classes = useStyles();
  const detail = props.issueDetail;

  useEffect(() => {
    detail.journals &&
      detail.journals.forEach((journal) => {
        const userId = journal.user?.id;
        if (userId) {
          if (!state.users?.some((existUser) => existUser.id === userId)) {
            getUser({
              id: userId,
              apikey: state.current.apikey,
              redmineurl: state.current.redmineurl,
            });
          }
        }
      });
  }, []);

  return (
    <>
      <List style={{ marginTop: 20, marginBottom: 30 }}>
        {detail.journals
          ? detail.journals.map((journal, index) => {
              if (journal.notes) {
                return (
                  <ListItem
                    alignItems="flex-start"
                    key={index}
                    style={{ marginBottom: 20 }}
                  >
                    <ListItemAvatar align="center" style={{ marginRight: 10 }}>
                      <CustomAvatar
                        className={classes.green}
                        userId={journal.user.id}
                        redmineurl={state.current?.redmineurl}
                      >
                        {journal.user.name.slice(0, 2)}
                      </CustomAvatar>
                    </ListItemAvatar>
                    <Box className={classes.note}>
                      {journal.created_on ? (
                        <ListItemText
                          secondary={new Date(
                            journal.created_on
                          ).toLocaleString()}
                        />
                      ) : null}
                      <TextileView text={journal.notes} />
                    </Box>
                  </ListItem>
                );
              }
            })
          : null}
      </List>
    </>
  );
};

export default NoteList;
